module.exports = __webpack_public_path__ + "static/media/jefferson.33ccd09b.png";